import {
  type ProgramActivityContentObjectList,
  type ProgramEventContentObjectList,
  type ProgramPollContentObjectList,
  type ProgramPostContentObjectList,
  type ProgramWithingsOrderPostContentObjectList,
  createProgramActivityContentObjectList,
  createProgramEventContentObjectList,
  createProgramPollContentObjectList,
  createProgramPostContentObjectList,
  createProgramWithingsOrderPostContentObjectList,
} from './content-object';
import type { ContentObjectListDataObject } from './service';

export type ProgramTimelineContentObject =
  | ProgramActivityContentObjectList
  | ProgramEventContentObjectList
  | ProgramPollContentObjectList
  | ProgramPostContentObjectList
  | ProgramWithingsOrderPostContentObjectList;

export const createProgramTimelineContentObject = (data: ContentObjectListDataObject): ProgramTimelineContentObject => {
  switch (data.type) {
    case 'activity':
      return createProgramActivityContentObjectList(data);

    case 'event':
      if (!('contentable_type' in data) || data.contentable_type !== 'Program') {
        throw new Error('Program timeline only supports program events');
      }

      return createProgramEventContentObjectList(data);

    case 'poll':
      if (data.contentable_type !== 'Program') {
        throw new Error('Program timeline only supports program polls');
      }

      return createProgramPollContentObjectList(data);

    case 'post':
      if (!('contentable_type' in data) || data.contentable_type !== 'Program') {
        throw new Error('Program timeline only supports program posts');
      }

      return createProgramPostContentObjectList(data);

    case 'withings_order_post':
      return createProgramWithingsOrderPostContentObjectList(data);

    case 'comment':
    case 'giving':
    case 'kudo':
    case 'video':
      throw new Error(`Unsupported program timeline content object type: ${data.type}`);
  }
};
